<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <task-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import TaskTable from "./components/TaskTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    TaskTable,
    // ProjectsTable,
  },
};
</script>
